import {
  faArrowsSpin,
  faArrowUpShortWide,
  faBoxArchive,
  faObjectGroup,
} from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import React from 'react';
import ConvertedUnits from 'src/components/ConvertedUnits';
import { MaterialsLayout } from 'src/components/MaterialsLayout';
import { getShortUuid } from 'src/utils/url';

const MaterialChips = ({ material, materialBatch, isMaterialLoading }) => {

  if (isMaterialLoading) {
    return <MaterialsLayout loading setLoading={() => {}} badges={[]} />;
  }

  if (!material || !materialBatch) {
    return null;
  }

  const badges = [
    {
      icon: faBoxArchive,
      text: getShortUuid(materialBatch.uuid),
      tooltip: 'Batch ID',
    },
    {
      icon: faObjectGroup,
      text: (
        <>
          {material.name}
          <span
            className="run-workstation-materials__color-dot"
            style={{ backgroundColor: material.color }}
          />
        </>
      ),
      tooltip: 'Material Type',
      className: 'run-workstation-materials__badge--material',
    },
    {
      icon: faArrowUpShortWide,
      text: <ConvertedUnits quantity={materialBatch.quantity} units={materialBatch.units} />,
      tooltip: 'Amount Loaded',
    },
    {
      icon: faArrowsSpin,
      text: materialBatch.usage_cycles,
      tooltip: 'Batch Usage Cycles',
    },
  ];

  return (
    <MaterialsLayout
      loading={false}
      setLoading={() => {}}
      badges={badges}
      label="MATERIALS"
    />
  );
};

MaterialChips.propTypes = {
  material: PropTypes.shape({
    name: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
  }).isRequired,
  materialBatch: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    // eslint-disable-next-line camelcase
    usage_cycles: PropTypes.number.isRequired,
    units: PropTypes.string.isRequired,
    quantity: PropTypes.number.isRequired,
  }).isRequired,
  isMaterialLoading: PropTypes.bool.isRequired,
};

export default MaterialChips;
